import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Blank from '../../../hoc/Blank/Blank';
import Input from '../../../components/UI/Input/Input';
import SignUpButtons from '../SignUpButtons/SignUpButtons';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './SignUp.css';
import * as actions from '../../../store/actions/index';
import { updateObject, checkValidity } from '../../../shared/utility';

class SignUp extends Component {
    state = {
        isValid:null,
        controls: {
            firstName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'First Name'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false
            },
            lastName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Last Name'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false
            },
            phone: {
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: 'Phone',
                    max:9999999999
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 0,
                    maxLength: 10,
                    isNumeric: true
                },
                valid: false,
                touched: false
            },
            userName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'User Name'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false
            }
        }
    }

    componentDidMount () {
        
    }

    componentWillUpdate () {
        if (this.props.isAuthenticated) {
            this.props.setPage('loads');
        }
    }

    inputChangedHandler = ( event, controlName ) => {
        let isValid = checkValidity( event.target.value, this.state.controls[controlName].validation )
        const updatedControls = updateObject( this.state.controls, {
            [controlName]: updateObject( this.state.controls[controlName], {
                value: event.target.value,
                valid: isValid,
                touched: true
            } )
        } );
        if (this.state.isValid)
        {
            if (!isValid) {
                this.setState({isValid:false});
            }
        }
        else {
            this.setState({isValid:true});
        }
        this.setState( { controls: updatedControls } );
    } 

    cancelSignup = () => {
        this.setPage('auth');
    }

    submitHandler = ( event ) => {
        event.preventDefault();
        if (this.state.isValid)
        {
            this.props.onSignUp(this.state.controls.firstName.value,
                this.state.controls.lastName.value,
                this.state.controls.phone.value,
                this.state.controls.userName.value );
        }
    }

    render () {
       
        const formElementsArray = [];
        for ( let key in this.state.controls ) {
            formElementsArray.push( {
                id: key,
                config: this.state.controls[key]
            } );
        }

        let form = formElementsArray.map( formElement => (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={( event ) => this.inputChangedHandler( event, formElement.id )} />
        ) );

        if ( this.props.loading ) {
            form = <Spinner />
        }

        let errorMessage = null;
console.log("ERROR:" + this.props.error);
        if ( this.props.error ) {
            errorMessage = (
                <p>{this.props.error}</p>
            );
        }

        return (
           
            <div className={classes.SignUp}>
                
                {errorMessage}
                <form>
                    {form}
                    <SignUpButtons  submitted={this.submitHandler} cancelled={this.cancelSignup}/>
                </form>
               
            </div>
                   );
    }
}

const mapStateToProps = state => {
    return {
        error: state.orders.errorMessage,
        isAuthenticated: state.orders.token !== null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSignUp: (firstName,lastName, phone, userName ) => dispatch( actions.signUp(firstName,lastName, phone,userName ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( SignUp );


// WEBPACK FOOTER //
// ./src/components/Security/SignUp/SignUp.js